module.exports = __webpack_public_path__ + "img/warning_sign.1e5dea87.png";